// src/pages/Trend/components/filters/TabNavigation.js
import React from 'react';
import PropTypes from 'prop-types';
import { LayoutDashboard, Store, BarChart3, ChevronRight } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import './TabNavigation.css';

const TAB_CONFIG = [
  { id: 'dashboard', icon: LayoutDashboard, labelKey: 'trendPage.tabs.dashboard', hasSubPanel: false },
  { id: 'brand', icon: Store, labelKey: 'trendPage.tabs.brand', hasSubPanel: true },
  { id: 'analysis', icon: BarChart3, labelKey: 'trendPage.tabs.analysis', hasSubPanel: true }
];

const TabNavigation = ({ activeTab, onTabSelect }) => {
  const { translate } = useLanguage();

  return (
    <div className="vertical-tab-navigation">
      <div className="tab-nav-list">
        {TAB_CONFIG.map(({ id, icon: Icon, labelKey, hasSubPanel }) => (
          <button
            key={id}
            className={`tab-nav-item ${activeTab === id ? 'active' : ''}`}
            onClick={() => onTabSelect(id, hasSubPanel)}
            type="button"
          >
            <div className="tab-nav-item-icon">
              <Icon size={18} />
            </div>
            <span className="tab-nav-item-label">{translate(labelKey) || id}</span>
            {hasSubPanel && <ChevronRight size={16} className="tab-nav-item-arrow" />}
          </button>
        ))}
      </div>
    </div>
  );
};

TabNavigation.propTypes = {
  activeTab: PropTypes.string,
  onTabSelect: PropTypes.func.isRequired
};

export default TabNavigation;
